import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../core/img/imagewithbasebath'
import { FileText, Home, RefreshCcw, ShoppingCart } from 'feather-icons-react/build/IconComponents'
import { CheckCircle, Trash2, UserPlus, CreditCard, DollarSign, Clock } from 'react-feather'
import Select from 'react-select'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

import PosLocationModal from "../../components/modals/Pos/PosLocationModal.jsx";
import ManagerApprovalModal from "../../components/modals/Common/ManagerApprovalModal.jsx";
import { MenuTreeService } from "../../../../src/services/sale/menuTreeService.ts"; // 🔹 adjust path if needed
import PriceCodeModal from "../../components/modals/Pos/PriceCodeModal.jsx";
import PosMenuModal from "../../components/modals/Pos/PosMenuModal.jsx";
import PosViewTabModal from "../../components/modals/Pos/PosViewTabModal.jsx";
import AddProductOptionsModal from "../../components/modals/Pos/AddProductOptionsModal.jsx";
import AddProductEditModal from "../../components/modals/Pos/AddProductEditModal.jsx";
import StaffPinModal from "../../components/modals/Common/StaffPinModal.jsx";
import AddTabModal from "../../components/modals/Pos/AddTabModal.jsx";
import { TabService } from "../../../services/sale/tabService.ts";
import TabSelectModal from "../../components/modals/Pos/TabSelectModal.jsx";
import { Users } from "react-feather";
import { SaleService } from "../../../services/sale/saleService.ts";


const Pos = () => {
    const tax = [
        { value: 'exclusive', label: 'Exclusive' },
        { value: 'inclusive', label: 'Inclusive' },
    ];
    const discounttype = [
        { value: 'percentage', label: 'Percentage' },
        { value: 'earlyPaymentDiscounts', label: 'Early payment discounts' },
    ];
    const units = [
        { value: 'kilogram', label: 'Kilogram' },
        { value: 'grams', label: 'Grams' },
    ];

    const CATEGORY_PLACEHOLDER = "assets/img/categories/category-01.png"; // default fallback image
    const [currentTab, setCurrentTab] = useState("newOrder"); // new: "newOrder" | "accounts" | "history"

    const [showManagerModal, setShowManagerModal] = useState(false);
    const [showLocationModal, setShowLocationModal] = useState(false);
    const [selectedMenuId, setSelectedMenuId] = useState(null);          // MenuID from location modal
    const [mainCategories, setMainCategories] = useState([]);             // no longer used
    const [selectedMainCategoryId, setSelectedMainCategoryId] = useState(null);
    const [, setSelectedMainCategoryName] = useState(""); // heading for products
    const [, setMenuProducts] = useState([]);                // products for selected item
    const [, setIsLoadingMenu] = useState(false);
    const [, setMenuError] = useState(null);

    const [showPriceModal, setShowPriceModal] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [showViewTabModal, setShowViewTabModal] = useState(false);
    const [showAddProductOptionsModal, setShowAddProductOptionsModal] = useState(false);
    const [selectedPriceItems, setSelectedPriceItems] = useState([]);  // result from PriceCodeModal
    const [currentProductName, setCurrentProductName] = useState("");  // product label for modal
    const [selectedCostCenter, setSelectedCostCenter] = useState(null);
    const [showMenuModal, setShowMenuModal] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [showAddTabModal, setShowAddTabModal] = useState(false);
    const [showStaffPinModal, setShowStaffPinModal] = useState(false);
    const [tabStaffSession, setTabStaffSession] = useState(null);
    const [showTabSelectModal, setShowTabSelectModal] = useState(false);
    const [selectedTab, setSelectedTab] = useState(null);
    const [tempProducts, setTempProducts] = useState([]);
    const [tabProducts, setTabProducts] = useState([]);
    const [editingIndex, setEditingIndex] = useState(null);
    const [managerAction, setManagerAction] = useState(null);

    // These must exist in your component state:
    const [discountNumber, setDiscountNumber] = useState("0");
    const [discountType, setDiscountType] = useState("%");

    const [gratuityNumber, setGratuityNumber] = useState("0");
    const [gratuityType, setGratuityType] = useState("%");

    // ---- LIVE TOTALS ----
    const [subTotal, setSubTotal] = useState(0);
    const [discountValue, setDiscountValue] = useState(0);
    const [gratuityValue, setGratuityValue] = useState(0);
    const [taxValue, setTaxValue] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [currencySymbol, setCurrencySymbol] = useState("$");

    const [paymentTypes, setPaymentTypes] = useState([]);
    const [primaryType, setPrimaryType] = useState(null);
    const [secondaryType, setSecondaryType] = useState(null);
    const [otherTypes, setOtherTypes] = useState([]);
    const [showOtherExpanded, setShowOtherExpanded] = useState(false);
    const [selectedOtherType, setSelectedOtherType] = useState(null);
    const [selectedPaymentType, setSelectedPaymentType] = useState(null);
    const [historyGuests, setHistoryGuests] = useState([]);
    const [selectedHistoryGuest, setSelectedHistoryGuest] = useState(null);


    // GST selection – TEMP until you hook your select
    const gstPercent = 5;
    const handleReorderProduct = (product) => {
        if (!product.TabLineID) {
            console.warn("Reorder blocked: TabLineID missing in product:", product);
            Swal.fire({
                icon: "warning",
                title: "Reorder Not Available",
                text: "This product cannot be reordered yet because TabLineID is missing.",
            });
            return;
        }

        Swal.fire({
            title: `<span style="font-size: 20px; font-weight: 600; color:#2c3e50;">Reorder Product</span>`,
            html: `
                  <div style="font-size: 15px; color:#555; margin-top: 6px;">
                    Do you want to reorder <b>${product.Product}</b>?
                  </div>
                `,
            background: "#f8f9fc",
            width: 420,
            padding: "20px 20px 15px 20px",
            showCancelButton: true,

            // BUTTONS
            confirmButtonText: "Order",
            cancelButtonText: "Cancel",

            // Apply your TMIS POS button styling
            customClass: {
                confirmButton: 'swal2-confirm-btn',
                cancelButton: 'swal2-cancel-btn'
            },

            buttonsStyling: false
        })
            .then(async (result) => {
                if (!result.isConfirmed) return;

                try {
                    const res = await SaleService.reorderTabLine(product.TabLineID);

                    if (!res) {
                        Swal.fire("Error", "Failed to reorder item.", "error");
                        return;
                    }

                    Swal.fire("Success", `${product.Product} reordered!`, "success");
                } catch (err) {
                    Swal.fire("Error", err.message ?? "Reorder failed.", "error");
                }
            });
    };

    const handleVoidTab = async () => {
        if (!selectedTab?.TabID) return;

        setManagerAction(() => async () => {
            const dto = {
                TabID: selectedTab.TabID,
                StaffID: tabStaffSession?.StaffID || 0,
                VoidReason: "Voided in POS"
            };

            const ok = await TabService.removeTab(dto);
            if (ok) {
                Swal.fire("Success", "Tab voided", "success");
                setSelectedTab(null);
                setTabProducts([]);
            } else {
                Swal.fire("Error", "Failed to void tab", "error");
            }
        });

        setShowManagerModal(true);
    };

    const handlePaySale = async () => {
        if (!selectedTab?.TabID) {
            Swal.fire("Error", "No active tab selected.", "error");
            return;
        }

        if (!selectedPaymentType?.PaymentTypeID) {
            Swal.fire("Error", "Select a payment method.", "error");
            return;
        }

        try {
            const dto = {
                TabID: selectedTab.TabID,
                PaymentTypeID: selectedPaymentType.PaymentTypeID,
                Gratuity: Number(gratuityNumber || 0),
                GratuityPercent: gratuityType === "%" ? Number(gratuityNumber || 0) : 0,
                Discount: Number(discountNumber || 0),
                DiscountPercent: discountType === "%" ? Number(discountNumber || 0) : 0,
                AmountPaid: grandTotal,
                AdditionalInfo: ""
            };

            const result = await SaleService.paySale(dto);

            if (!result) {
                Swal.fire("Error", "Payment failed.", "error");
                return;
            }

            Swal.fire("Success", "Payment completed!", "success");

            // Reset tab UI
            setSelectedTab(null);
            setTabProducts([]);
            setTempProducts([]);
        } catch (err) {
            Swal.fire("Error", err.message || "Payment failed.", "error");
        }
    };


    const handleVoidTabLine = (tabLineId) => {
        if (!tabLineId) return;

        setManagerAction(() => async () => {
            const dto = {
                TabLineID: tabLineId,
                StaffID: tabStaffSession?.StaffID || 0,
                VoidReason: "Voided in POS",
            };

            const ok = await TabService.removeTabLine(dto);
            if (ok) {
                setTabProducts((prev) => prev.filter((x) => x.TabLineID !== tabLineId));
            } else {
                Swal.fire("Error", "Failed to void tab line", "error");
            }
        });

        setShowManagerModal(true);
    };


    const handlePaymentTypeSelect = (type) => {
        console.log("Selected Payment Type:", type);
        setSelectedPaymentType(type);

        // Collapse "Other" menu if open
        setShowOtherExpanded(false);

        // If selecting an other type, store it
        if (!type.IsPrimary && !type.IsSecondary) {
            setSelectedOtherType(type);
        }
    };
    const handleClearAllProducts = () => {
        setTempProducts([]);
    };

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );
    const renderPrinterTooltip = (props) => (
        <Tooltip id="printer-tooltip" {...props}>
            Printer
        </Tooltip>
    );

    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = () => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#ff0000',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {

                MySwal.fire({
                    title: 'Deleted!',
                    text: 'Your file has been deleted.',
                    className: "btn btn-success",
                    confirmButtonText: 'OK',
                    customClass: {
                        confirmButton: 'btn btn-success',
                    },
                });
            } else {
                MySwal.close();
            }

        });
    };

    const loadMainCategories = async (menuId) => {
        if (!menuId) return;
        setIsLoadingMenu(true);
        setMenuError(null);

        try {
            const data = await MenuTreeService.getAllMenuTree(menuId, null);

            // These are your categories for this menu (e.g. Grill, Hamburgers, Breakfast)
            setMainCategories(data || []);

            // 🔹 Build ONE list with ALL products from ALL categories
            const allProducts = [];
            (data || []).forEach(cat => {
                if (Array.isArray(cat.Product)) {
                    allProducts.push(...cat.Product);
                }
            });

            // When a menu (e.g. Dinner) is opened, show ALL its products
            setMenuProducts(allProducts);

            // Nothing specifically selected yet
            setSelectedMainCategoryId(null);
            setSelectedMainCategoryName("");
        } catch (err) {
            console.error("Error loading main categories:", err);
            setMenuError("Failed to load menu.");
        } finally {
            setIsLoadingMenu(false);
        }
    };

    const handleMainCategoryClick = async (item) => {
        // We still want the label for possible future use
        setSelectedMainCategoryName(item.Item);

        // ✅ CASE 1: Category has children (e.g. Dinner → Grill/Hamburgers/Breakfast)
        if (item.ItemCount > 0) {
            const childCats = await MenuTreeService.getAllMenuTree(
                selectedMenuId,
                item.ItemID
            );

            // drill down: replace with children
            setMainCategories(childCats);

            // merge all child products (keeps existing behaviour)
            const allProducts = mergeChildProducts(childCats);
            setMenuProducts(allProducts);

            // ❗ NO FILTER here – we want to see ALL child categories
            setSelectedMainCategoryId(null);
            return;
        }

        // ✅ CASE 2: Leaf category – no children, only products (e.g. Grill / Hamburgers)
        // Clicking this should act as a filter on the product list.

        // If already selected, toggle off and show all again
        if (selectedMainCategoryId === item.ItemID) {
            setSelectedMainCategoryId(null);
        } else {
            setSelectedMainCategoryId(item.ItemID);
        }

        // still keep menuProducts in case you use it later
        if (item.ProductCount > 0 && Array.isArray(item.Product)) {
            setMenuProducts(item.Product);
        } else {
            setMenuProducts([]);
        }
    };


    const handleProductClick = (productId, productName) => {
        // ✅ Require an active tab before adding products
        if (!selectedTab || !selectedTab.TabID) {
            Swal.fire(
                "No tab selected",
                "Please create or select a tab before adding products.",
                "warning"
            );
            return;
        }

        // 🔥 NEW: this is a *new* add, never treat it as an edit
        setEditingIndex(null);

        setSelectedProductId(productId);
        setCurrentProductName(productName);   // store for next modals
        setShowPriceModal(true);
    };

    useEffect(() => {
        let total = 0;

        // SUM ALL UNITCOST × QTY
        tabProducts.forEach(p => {
            total += Number(p.UnitCostIncl || 0) * Number(p.Quantity || 1);
        });

        setSubTotal(total);

        // ----- DISCOUNT -----
        let d = 0;
        if (discountType === "%") {
            d = total * (Number(discountNumber || 0) / 100);
        } else {
            d = Number(discountNumber || 0);
        }
        setDiscountValue(d);

        // ----- GRATUITY -----
        let g = 0;
        if (gratuityType === "%") {
            g = total * (Number(gratuityNumber || 0) / 100);
        } else {
            g = Number(gratuityNumber || 0);
        }
        setGratuityValue(g);

        // ----- TAX -----
        const taxCalc = (total - d + g) * (gstPercent / 100);
        setTaxValue(taxCalc);

        // ----- GRAND TOTAL -----
        setGrandTotal(total - d + g + taxCalc);

    }, [tabProducts, discountNumber, discountType, gratuityNumber, gratuityType]);


    useEffect(() => {
        const savedLocation = localStorage.getItem("pos_location");

        if (!savedLocation) {
            setShowLocationModal(true);
        }

        // 🔹 NEW: restore full cost center from localStorage
        const storedCCObj = localStorage.getItem("selectedCostCenterObject");
        if (storedCCObj) {
            try {
                const parsed = JSON.parse(storedCCObj);
                setSelectedCostCenter(parsed);
            } catch (e) {
                console.error("[POS] failed to parse selectedCostCenterObject:", e);
            }
        }

        const savedMenuId = localStorage.getItem("selectedMenuId");
        if (savedMenuId) {
            const id = parseInt(savedMenuId, 10);
            if (!isNaN(id)) {
                setSelectedMenuId(id);
            }
        }

        SaleService.getPaymentTypes()
            .then((data) => {
                if (!data) return;

                setPaymentTypes(data);

                setPrimaryType(data.find(x => x.IsPrimary) || null);
                setSecondaryType(data.find(x => x.IsSecondary) || null);

                setOtherTypes(
                    data.filter(x => !x.IsPrimary && !x.IsSecondary)
                );
            })
            .catch(err => console.warn("Failed loading payment types:", err));


        // 🔥 LOAD CURRENCY SYMBOL HERE
        SaleService.getCurrency()
            .then((res) => {
                if (res && res.Currency) {
                    setCurrencySymbol(res.Currency);
                }
            })
            .catch((err) => {
                console.warn("Failed to load currency:", err);
            });

    }, []);

    // 🔥 Listen for menu change events (from Header or other pages)
    useEffect(() => {
        const handleMenuChanged = (e) => {
            const menuId = e.detail.menuId;

            // Updates state → triggers your existing useEffect
            setSelectedMenuId(menuId);
        };

        window.addEventListener("POS_MENU_CHANGED", handleMenuChanged);

        return () =>
            window.removeEventListener("POS_MENU_CHANGED", handleMenuChanged);
    }, []);

    useEffect(() => {
        window.__addProductsToPosTemp = (rows) => {
            setTempProducts(prev => [...prev, ...rows]);
        };
    }, []);

    useEffect(() => {
        window.__editTempProduct = (index, newItem) => {
            setTempProducts(prev => {
                const updated = [...prev];
                updated[index] = newItem;
                return updated;
            });
        };
    }, []);


    // 🔹 Whenever MenuID changes, load main categories
    useEffect(() => {
        if (selectedMenuId) {
            loadMainCategories(selectedMenuId);
        }
    }, [selectedMenuId]);

    useEffect(() => {
        if (currentTab !== "history") return;
        if (!selectedTab?.FK_AccountID) return;

        SaleService.listOrderHistory(selectedTab.FK_AccountID)
            .then((res) => {
                setHistoryGuests(res || []);
            })
            .catch(() => {
                setHistoryGuests([]);
            });

    }, [currentTab, selectedTab]);


    // 🔹 Called by PosLocationModal when a store is selected
    const handleLocationSelect = (cc) => {

        // keep current behaviour
        setSelectedCostCenter(cc);

        // for other pages / future restores
        localStorage.setItem("selectedCostCenter", cc.CostCenter);
        localStorage.setItem("selectedCostCenterID", cc.CostCenterID);
        localStorage.setItem("selectedCostCenterObject", JSON.stringify(cc));

        // 🔹 THIS is what stops the location modal from reopening every time
        localStorage.setItem("pos_location", String(cc.CostCenterID));

        // open the menu modal
        setShowMenuModal(true);
    };


    const resetToHome = async () => {
        setSelectedHistoryGuest(null);  // <-- ADD THIS

        if (!selectedMenuId) return;
        const topLevel = await MenuTreeService.getAllMenuTree(selectedMenuId, null);

        setMainCategories(topLevel);
        const merged = mergeChildProducts(topLevel);
        setMenuProducts(merged);

        setSelectedMainCategoryId(null);
        setSelectedMainCategoryName("");
    };


    const mergeChildProducts = (categories) => {
        const merged = [];
        categories.forEach(cat => {
            if (Array.isArray(cat.Product)) {
                merged.push(...cat.Product);
            }
        });
        return merged;
    };

    // ---- MERGE TEMP PRODUCTS BY PRODUCT NAME ----
    const mergedTempProducts = Object.values(
        tempProducts
            .filter((item) => !item._isChild)   // ⬅️ child products hidden on the product list
            .reduce((acc, item) => {
                const key = item.Product || "";

                if (!acc[key]) {
                    acc[key] = {
                        productName: item.Product,
                        items: [],
                    };
                }

                acc[key].items.push(item);
                return acc;
            }, {})
    );


    const visibleCategories = mainCategories
        .filter(cat => Array.isArray(cat.Product) && cat.Product.length > 0) // must have products
        .filter(cat =>
            // if a filter is active, only show that one category
            !selectedMainCategoryId || cat.ItemID === selectedMainCategoryId
        );

    return (
        <div>
            <div className="page-wrapper pos-pg-wrapper ms-0">
                <div className="content pos-design p-0">
                    <div className="pos-header-bar">

                        {/* LEFT BUTTON GROUP */}
                        <div className="pos-header-left">
                            <Link to="#" className="pos-action-btn btn-warning" onClick={resetToHome}>
                                <Home className="feather-16" />
                            </Link>
                        </div>


                        {/* MIDDLE SECTION (Order Info) */}
                        <div className="pos-header-middle">
                            {/* Show ONLY if an account/tab is selected */}
                            {selectedTab?.FK_AccountID && (
                                <>
                                    <Link
                                        to="#"
                                        className={`pos-action-btn btn-info ${currentTab === "newOrder" ? "active" : ""}`}
                                        onClick={() => setCurrentTab("newOrder")}
                                    >
                                        <ShoppingCart className="feather-16" />
                                    </Link>

                                    <Link
                                        to="#"
                                        className={`pos-action-btn btn-danger ${currentTab === "viewOrder" ? "active" : ""}`}
                                        onClick={() => setCurrentTab("viewOrder")}
                                    >
                                        <CreditCard className="feather-16" />
                                    </Link>

                                    <Link
                                        to="#"
                                        className={`pos-action-btn btn-success ${currentTab === "history" ? "active" : ""}`}
                                        onClick={() => setCurrentTab("history")}
                                    >
                                        <Clock className="feather-16" />
                                    </Link>
                                </>
                            )}

                            <Link to="#" className="pos-action-btn btn-primary" onClick={() => setShowViewTabModal(true)}>
                                <FileText className="feather-16" />
                            </Link>

                            {/* <Link to="#" className="pos-action-btn" data-bs-toggle="modal" data-bs-target="#recents">
                                <RefreshCcw className="feather-16" />
                            </Link> */}

                        </div>

                        {/* RIGHT BUTTONS */}
                        <div className="pos-header-right">
                            <Link
                                to="#"
                                className="pos-action-btn btn-warning"
                                onClick={() => setShowStaffPinModal(true)}   // 🔥 first step = staff login
                            >
                                <UserPlus className="feather-16" />
                            </Link>


                        </div>

                    </div>

                    <div className="row align-items-start pos-wrapper">
                        {/* 🔵 Blue block (products, categories, etc.) */}
                        {currentTab === "newOrder" && (

                            <div className="row g-0" style={{ height: "calc(100vh - 180px)" }}>
                                {/* LEFT – CATEGORIES (vertical carousel) */}
                                <div className="col-12 col-lg-8 d-flex flex-column border-end"
                                    style={{ height: "100%", overflowY: "auto" }}>
                                    {/* CATEGORY GRID (replaces Slider completely) */}
                                    <div className="category-block p-3">

                                        {/* Category Section Heading */}
                                        <div className="d-flex align-items-center mb-3">

                                        </div>


                                        <div
                                            className="d-flex flex-wrap gap-3"
                                            style={{ rowGap: "20px", columnGap: "20px" }}
                                        >
                                            {mainCategories.map((cat) => (
                                                <div
                                                    key={cat.ItemID}
                                                    className={`category-card shadow-sm p-3 text-center`}
                                                    style={{
                                                        background: selectedMainCategoryId === cat.ItemID ? "#eef6ff" : "white",
                                                        border: selectedMainCategoryId === cat.ItemID ? "2px solid #0d6efd" : "1px solid #ddd"
                                                    }}
                                                    onClick={() => handleMainCategoryClick(cat)}
                                                >
                                                    <img
                                                        src={cat.MenuItemImage || CATEGORY_PLACEHOLDER}
                                                        alt={cat.Item}
                                                        className="img-fluid mb-2"
                                                    />

                                                    <h6 className="mb-1">{cat.Item}</h6>

                                                    {/* Badges */}
                                                    <div>
                                                        {cat.ProductCount > 0 && (
                                                            <span className="badge bg-primary me-1">
                                                                {cat.ProductCount} Products
                                                            </span>
                                                        )}

                                                        {cat.ItemCount > 0 && (
                                                            <span className="badge bg-info">
                                                                {cat.ItemCount} Subs
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* PRODUCT BLOCKS */}
                                    <div className="products-area mt-4 p-3">

                                        {/* Dinner / Lunch / Breakfast TITLE */}
                                        {/* {selectedMainCategoryName && (
                                            <h5 className="mb-4">{selectedMainCategoryName}</h5>
                                        )} */}

                                        {visibleCategories.map(cat => (
                                            <div key={cat.ItemID} className="mb-5">
                                                {/* CATEGORY TITLE */}
                                                <h5 className="mb-3">{cat.Item}</h5>

                                                <div
                                                    className="d-flex flex-wrap"
                                                    style={{
                                                        gap: "15px",
                                                        rowGap: "25px",
                                                    }}
                                                >
                                                    {cat.Product.map((prod) => (
                                                        <div
                                                            key={prod.ProductID}
                                                            className="pos-product-card-wide card"
                                                            onClick={() => handleProductClick(prod.ProductID, prod.Product)}
                                                            style={{
                                                                cursor: "pointer",
                                                                width: "140px",
                                                                height: "140px",
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            <div
                                                                className="pos-product-image-wide"
                                                                style={{
                                                                    background: "#f5f7fb",
                                                                    borderRadius: "6px",
                                                                    height: "95px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                            >
                                                                <img
                                                                    src={prod.ProductImage || "assets/img/products/noProduct.jpg"}
                                                                    alt={prod.Product}
                                                                    style={{ maxHeight: "80%", maxWidth: "80%" }}
                                                                />
                                                            </div>

                                                            <div style={{ padding: "8px 10px" }}>
                                                                <h6
                                                                    className="mb-0"
                                                                    style={{ fontSize: "14px", fontWeight: "600" }}
                                                                >
                                                                    {prod.Product}
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>

                                {/* RIGHT – ORDER PANEL (4 columns) */}
                                <div className="col-12 col-lg-4 d-flex flex-column"
                                    style={{ height: "100%", overflowY: "auto" }}>

                                    {/* If you want a header fixed at top */}
                                    <div className="flex-shrink-0">

                                        <div className="btn-row d-sm-flex align-items-center justify-content-between">
                                            <button
                                                className="pos-action-btn btn-warning"
                                                onClick={() => setShowTabSelectModal(true)}
                                            >
                                                <Users size={16} style={{ marginRight: 6 }} />
                                            </button>


                                            <span className="mb-0" style={{ fontWeight: 600, fontSize: "20px" }}>
                                                {selectedTab && selectedTab.TabName
                                                    ? `${selectedTab.TabName}${selectedTab.TableNumber ? ` (Table ${selectedTab.TableNumber})` : ""}`
                                                    : "Open Tab"}
                                            </span>

                                            {/* Delete button */}
                                            <Link
                                                className="pos-action-btn btn-danger"
                                                to="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleVoidTab();
                                                }}
                                            >
                                                <Trash2 className="feather-16" />
                                            </Link>

                                        </div>
                                        <div className="btn-row d-sm-flex align-items-center justify-content-between">

                                            {/* Place Order */}
                                            <Link
                                                to="#"
                                                className="pos-action-btn btn-success btn-icon flex-fill"
                                                onClick={() => {

                                                    console.log("tempProducts: ", tempProducts)
                                                    // STEP 1 — Generate products in required format
                                                    // ------------------------------------------------------
                                                    // 1) INDEX CHILD POINTER IDS BY SUBSTITUTE + GUEST + PRICE
                                                    // ------------------------------------------------------
                                                    const childPointerIndex = new Map();

                                                    /**
                                                     * We index child rows (substitutes) so that when we build the
                                                     * parent product's Combinations[].Substitutions[], we can look
                                                     * up the correct PointerID based on:
                                                     *   - SubstituteName
                                                     *   - GuestId
                                                     *   - PriceCodeID
                                                     */
                                                    tempProducts.forEach((p) => {
                                                        if (!p._isChild) return;
                                                        if (!p.PointerID) return;

                                                        const key = [
                                                            p.SubstituteName ?? "",
                                                            p.GuestId ?? "",
                                                            p.FK_PriceCodeID ?? p.PriceCodeID ?? "",
                                                        ].join("|");

                                                        if (!childPointerIndex.has(key)) {
                                                            childPointerIndex.set(key, p.PointerID);
                                                        }
                                                    });

                                                    // ------------------------------------------------------
                                                    // 2) BUILD PRODUCT OBJECTS
                                                    // ------------------------------------------------------
                                                    const builtProducts = tempProducts.map((p) => {
                                                        const sel = p.SelectionState ?? {};

                                                        // ------------------ COST LOGIC ------------------
                                                        let unitExcl = Number(p.UnitPrice ?? 0);
                                                        let vat = Number(p.Vat ?? 0);
                                                        let unitIncl = unitExcl + vat;

                                                        // If this is a free substitute (no extra charge), zero out costs
                                                        if (p.IsExtraCharge === false) {
                                                            unitExcl = 0;
                                                            vat = 0;
                                                            unitIncl = 0;
                                                        }

                                                        // ------------------ COMBINATIONS ------------------
                                                        const combinations = [];
                                                        const comboSets = p.CombinationSets ?? [];
                                                        const ingredientNotes = sel.ingredientNotes ?? p.IngredientNotes ?? {};

                                                        comboSets.forEach((combo) => {
                                                            (combo.CombinationItems || []).forEach((item) => {
                                                                const name = item.ProductItemName;
                                                                if (!name) return;

                                                                const hold = !!(sel.holds || {})[name];
                                                                const note = ingredientNotes[name] ?? "";

                                                                // ----- Substitution -----
                                                                const subName = (sel.subs || {})[name] ?? "";
                                                                let subId = null;
                                                                let subPointerId = null;

                                                                if (subName) {
                                                                    const subObj = (item.SubstituitonItems || []).find(
                                                                        (s) => s.SubstituteProductName === subName
                                                                    );
                                                                    if (subObj) {
                                                                        subId = subObj.FK_ProductSubstitutionID ?? null;
                                                                    }

                                                                    // Find matching child (Side Salad, same guest + price code)
                                                                    const pointerKey = [
                                                                        subName,
                                                                        p.GuestId ?? "",
                                                                        p.FK_PriceCodeID ?? p.PriceCodeID ?? "",
                                                                    ].join("|");
                                                                    subPointerId = childPointerIndex.get(pointerKey) ?? null;
                                                                }

                                                                // ----- Preparation -----
                                                                const prepName = (sel.preps || {})[name] ?? "";
                                                                let prepId = null;
                                                                if (prepName) {
                                                                    const prepObj = (item.Methods || []).find(
                                                                        (m) => m.Method === prepName
                                                                    );
                                                                    if (prepObj) {
                                                                        prepId = prepObj.FK_MethodID ?? null;
                                                                    }
                                                                }

                                                                combinations.push({
                                                                    ProductCombinationID: item.FK_ProductItemID ?? null,
                                                                    CombinationName: name,
                                                                    Hold: hold,
                                                                    Notes: note,
                                                                    Substitutions: subName
                                                                        ? [
                                                                            {
                                                                                FK_SubstitutionID: subId,
                                                                                PointerID: subPointerId, // 🔗 link to child product
                                                                                SubstitutionName: subName,
                                                                            },
                                                                        ]
                                                                        : [],
                                                                    PreperationMethods: prepName
                                                                        ? [
                                                                            {
                                                                                PreperationMethodID: prepId,
                                                                                PreperationMethodName: prepName,
                                                                            },
                                                                        ]
                                                                        : [],
                                                                });
                                                            });
                                                        });

                                                        // ------------------ EXTRAS ------------------
                                                        const extras = [];
                                                        Object.entries(sel.extras || {}).forEach(([cat, arr]) => {
                                                            if (!Array.isArray(arr)) return;

                                                            arr.forEach((value) => {
                                                                if (!value) return;

                                                                const isObj = typeof value === "object";
                                                                const name = isObj ? value.label || value.name || "" : String(value);
                                                                const qty = isObj ? value.quantity ?? 1 : 1;
                                                                const extraProductId = isObj ? value.value ?? value.extraProductId ?? null : null;
                                                                const productExtraId = isObj ? value.productExtraId ?? null : null;
                                                                const isExtraCharge =
                                                                    isObj && typeof value.isExtraCharge === "boolean"
                                                                        ? value.isExtraCharge
                                                                        : true;

                                                                extras.push({
                                                                    ProductExtraID: productExtraId,
                                                                    ExtraProductID: extraProductId,
                                                                    ExtraName: name,
                                                                    Category: cat,
                                                                    Quantity: qty,
                                                                    IsExtraCharge: isExtraCharge,
                                                                });
                                                            });
                                                        });


                                                        // ------------------ FINAL PRODUCT OBJECT ------------------
                                                        return {
                                                            FK_ProductID: p.FK_ProductID,

                                                            // Only child rows carry a PointerID in the final JSON
                                                            PointerID: p._isChild ? p.PointerID ?? null : null,

                                                            Product: p.Product,
                                                            FK_PriceCodeID: p.FK_PriceCodeID,

                                                            UnitCostExcl: unitExcl,
                                                            Vat: vat,
                                                            UnitCostIncl: unitIncl,

                                                            Discount: p.Discount ?? 0,
                                                            DiscountPerc: p.DiscountPerc ?? 0,
                                                            Quantity: p.Quantity ?? 1,
                                                            ExtraNotes: p.ExtraNotes ?? "",
                                                            GuestID: p.GuestId ?? null,
                                                            AutoNotes: p.AutoNotes ?? [],
                                                            Combinations: combinations,
                                                            Extras: extras,
                                                        };
                                                    });

                                                    // ------------------ FINAL ORDER WRAPPER ------------------
                                                    const finalOrder = {
                                                        MenuID: selectedMenuId ?? null,
                                                        FK_StaffID: tabStaffSession?.StaffID ?? 0,
                                                        Products: builtProducts,
                                                    };

                                                    console.log("ORDER JSON:", finalOrder);


                                                }}


                                            >
                                                <span className="me-1 d-flex align-items-center">
                                                    <i data-feather="credit-card" className="feather-16" />
                                                </span>
                                                Place Order
                                            </Link>

                                            {/* Clear Selection */}
                                            <Link
                                                to="#"
                                                className="pos-action-btn btn-danger btn-icon flex-fill"
                                                onClick={handleClearAllProducts}
                                            >
                                                <span className="me-1 d-flex align-items-center">
                                                    <i data-feather="trash-2" className="feather-16" />
                                                </span>
                                                Clear Selection
                                            </Link>
                                        </div>
                                    </div>

                                    {/* Scroll area */}
                                    <div className="flex-grow-1" style={{ overflowY: "auto", background: "#f8f9fc" }}>
                                        <div className="product-order-list" style={{ flex: 1, overflowY: "auto" }}>
                                            <div className="product-added block-section">
                                                <div
                                                    className="product-wrap-custom p-1"
                                                    style={{
                                                        background: "#f8f9fc",      // ← grey area for ALL products
                                                        borderRadius: "12px",
                                                        boxShadow: "0 0 0 1px #f2f3f5 inset"
                                                    }}
                                                >
                                                    {tempProducts.length === 0 && (
                                                        <p className="text-center text-muted mt-3">No products selected</p>
                                                    )}

                                                    {mergedTempProducts.map((group, groupIndex) => {
                                                        const first = group.items[0];
                                                        if (!first) return null;

                                                        group.items.forEach((item) => {
                                                            if (typeof item._expanded === "undefined") item._expanded = false;
                                                            if (typeof item._notesExpanded === "undefined")
                                                                item._notesExpanded = true;
                                                        });

                                                        const totalQty = group.items.reduce(
                                                            (sum, item) => sum + (item.Quantity ?? 1),
                                                            0
                                                        );

                                                        const price =
                                                            first.UnitCostIncl?.parsedValue != null
                                                                ? Number(first.UnitCostIncl.parsedValue).toFixed(2)
                                                                : "No price loaded";

                                                        return (
                                                            <div
                                                                key={first.TabLineID || `${first.Product}-${groupIndex}`}
                                                                className="p-3 rounded mb-1"
                                                                style={{ background: "transparent" }}
                                                            >
                                                                {/* MAIN ROW */}
                                                                <div
                                                                    className="p-3 rounded mb-2"
                                                                    style={{
                                                                        background: "#ffffff",
                                                                        borderRadius: "10px",
                                                                        boxShadow: "0 0 0 1px #e3e6ef inset"
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="product-list d-flex align-items-center justify-content-between"
                                                                        style={{
                                                                            background: "transparent",
                                                                            border: "none",
                                                                            boxShadow: "none",
                                                                            padding: 0,
                                                                            margin: 0
                                                                        }}
                                                                    >
                                                                        <div className="d-flex align-items-center product-info">
                                                                            <Link
                                                                                to="#"
                                                                                className="img-bg"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    const newExpanded = !first._expanded;
                                                                                    group.items.forEach((item) => {
                                                                                        item._expanded = newExpanded;
                                                                                    });
                                                                                    setTempProducts([...tempProducts]);
                                                                                }}
                                                                            >
                                                                                <ImageWithBasePath
                                                                                    src="assets/img/products/tempburger.jpg"
                                                                                    alt="Product"
                                                                                />
                                                                            </Link>

                                                                            <div className="info">

                                                                                {/* 🔥 REMOVED BLUE PRODUCT CODE COMPLETELY */}

                                                                                {/* 🔥 TITLE WITH TOTAL QUANTITY */}
                                                                                <h6>
                                                                                    <Link
                                                                                        to="#"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();

                                                                                            const selectedItems = group.items.map((p) => ({
                                                                                                ...p.PriceOptionRaw,
                                                                                                qty: p.Quantity,
                                                                                                selectionState: p.SelectionState ?? {},
                                                                                                autoNotes: p.AutoNotes ?? [],
                                                                                                ingredientNotes: p.IngredientNotes ?? {},
                                                                                                extraNotes: p.ExtraNotes ?? "",
                                                                                                guest: p.Guest ?? null,
                                                                                                combinations: p.CombinationSets ?? [],
                                                                                                priceCodeId: p.FK_PriceCodeID,
                                                                                                PriceCodeID: p.FK_PriceCodeID,
                                                                                                PriceCode: p.PriceCode,
                                                                                                description: p.PriceDescription,
                                                                                                FK_ProductID: p.FK_ProductID,
                                                                                            }));

                                                                                            const firstIndex = tempProducts.indexOf(first);
                                                                                            setEditingIndex(firstIndex);

                                                                                            setSelectedPriceItems(selectedItems);
                                                                                            setSelectedProductId(first.FK_ProductID);
                                                                                            setCurrentProductName(first.Product);

                                                                                            setShowAddProductOptionsModal(true);
                                                                                        }}
                                                                                    >
                                                                                        {totalQty} × {first.Product}
                                                                                    </Link>
                                                                                </h6>

                                                                                {/* 🔥 PRICE = SUM(QTY × UNITCOST) */}
                                                                                <p style={{ fontWeight: 600 }}>
                                                                                    {group.items
                                                                                        .reduce((sum, item) => {
                                                                                            const price =
                                                                                                item.UnitCostIncl?.parsedValue ??
                                                                                                item.UnitCostIncl ??
                                                                                                0;
                                                                                            return sum + Number(price) * (item.Quantity ?? 1);
                                                                                        }, 0)
                                                                                        .toFixed(2)}
                                                                                </p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="d-flex align-items-center action">
                                                                            <Link
                                                                                className="btn-icon delete-icon confirm-text"
                                                                                to="#"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    setTempProducts((prev) =>
                                                                                        prev.filter((p) => !group.items.includes(p))
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <Trash2 className="feather-14" />
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* NOTES */}
                                                                {first._expanded && (
                                                                    <div
                                                                        className="mt-2"
                                                                        style={{
                                                                            background: "transparent",
                                                                            paddingLeft: "12px",   // aligns with product card left padding
                                                                            paddingRight: "12px",  // aligns with product card right padding
                                                                        }}
                                                                    >
                                                                        {group.items.map((p, idx) => (
                                                                            <div
                                                                                key={idx}
                                                                                className="p-2 rounded mb-1"
                                                                                style={{
                                                                                    background: "#ffffff",
                                                                                    borderRadius: "10px",
                                                                                    // subtle inset separation (optional)
                                                                                    boxShadow: "0 0 0 1px #f7f7f7 inset"
                                                                                }}
                                                                            >
                                                                                <div
                                                                                    className="fw-bold"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        p._notesExpanded = !p._notesExpanded;
                                                                                        setTempProducts([...tempProducts]);
                                                                                    }}
                                                                                >
                                                                                    {(p.Guest || "Guest") +
                                                                                        (p.PriceCode ? ` (${p.PriceCode})` : "")}
                                                                                </div>

                                                                                {p._notesExpanded && (
                                                                                    <div className="mt-2 ms-1 small">
                                                                                        {p.ExtraNotes && (
                                                                                            <div className="mb-1">
                                                                                                <strong>Extra: </strong>
                                                                                                {p.ExtraNotes}
                                                                                            </div>
                                                                                        )}

                                                                                        {Array.isArray(p.AutoNotes) &&
                                                                                            p.AutoNotes.map((n, i) => (
                                                                                                <div key={i}>• {n}</div>
                                                                                            ))}

                                                                                        {p.IngredientNotes &&
                                                                                            Object.entries(p.IngredientNotes).map(([k, v]) =>
                                                                                                v ? (
                                                                                                    <div key={k}>
                                                                                                        {k}: {v}
                                                                                                    </div>
                                                                                                ) : null
                                                                                            )}
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>


                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        )}

                        {currentTab === "viewOrder" && (
                            <div className="col-md-12 col-lg-12 ps-0">
                                {/* 🔴 Red block (order list) */}
                                <aside className="product-order-list">

                                    <div className="product-added block-section">
                                        <div className="head-text d-flex align-items-center justify-content-between">
                                            <h6 className="d-flex align-items-center mb-0">
                                                Product Added
                                            </h6>
                                            <Link
                                                to="#"
                                                className="d-flex align-items-center text-danger"
                                            >
                                                <span className="me-1">
                                                    <i data-feather="x" className="feather-16" />
                                                </span>
                                                Clear all
                                            </Link>
                                        </div>
                                        <div className="product-wrap">
                                            {tabProducts.length === 0 && (
                                                <p className="text-center text-muted mt-3">No items in this tab</p>
                                            )}
                                            {tabProducts.map((line) => {
                                                // initialise expanded flag ON the object itself so no hook needed
                                                if (typeof line._expanded === "undefined") {
                                                    line._expanded = false;
                                                }

                                                const price =
                                                    line.UnitCostIncl?.parsedValue != null
                                                        ? Number(line.UnitCostIncl.parsedValue).toFixed(2)
                                                        : "No price loaded";

                                                return (
                                                    <div key={line.TabLineID} className="w-100">

                                                        {/* MAIN ROW */}
                                                        <div className="product-list d-flex align-items-center justify-content-between">

                                                            {/* LEFT: IMAGE (toggle notes) */}
                                                            <div className="d-flex align-items-center product-info">
                                                                <Link
                                                                    to="#"
                                                                    className="img-bg"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        line._expanded = !line._expanded;
                                                                        // 🔥 use tabProducts, not tempProducts
                                                                        setTabProducts([...tabProducts]);
                                                                    }}
                                                                >
                                                                    <ImageWithBasePath
                                                                        src="assets/img/products/tempburger.jpg"
                                                                        alt="Product"
                                                                    />
                                                                </Link>

                                                                <div className="info">
                                                                    <span>{line.PriceCode}</span>

                                                                    {/* PRODUCT NAME — clicking opens edit modal with manager approval */}
                                                                    <h6>
                                                                        <Link
                                                                            to="#"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();

                                                                                setManagerAction(() => () => {
                                                                                    const selected = {
                                                                                        ...line.PriceOptionRaw,
                                                                                        qty: 1,
                                                                                        priceCodeId: line.FK_PriceCodeID,
                                                                                        PriceCodeID: line.FK_PriceCodeID,
                                                                                        PriceCode: line.PriceCode,
                                                                                        description: line.PriceDescription,
                                                                                        selectionState: line.SelectionState ?? {},
                                                                                        autoNotes: line.AutoNotes ?? [],
                                                                                        ingredientNotes: line.IngredientNotes ?? {},
                                                                                        extraNotes: line.ExtraNotes ?? "",
                                                                                        combinations: line.CombinationSets ?? [],
                                                                                        guest: line.Guest ?? null,
                                                                                    };

                                                                                    setSelectedPriceItems([selected]);
                                                                                    setSelectedProductId(line.FK_ProductID);
                                                                                    setCurrentProductName(line.Product);

                                                                                    // ❌ DO NOT set editingRow here for tab products
                                                                                    // setEditingRow({ index: tabProducts.indexOf(line), originalLine: line });

                                                                                    setShowAddProductOptionsModal(true);
                                                                                });

                                                                                setShowManagerModal(true);
                                                                            }}

                                                                        >
                                                                            {line.Product}
                                                                        </Link>
                                                                    </h6>

                                                                    <p>{price}</p>
                                                                </div>
                                                            </div>

                                                            {/* RIGHT: DELETE (with manager approval) */}
                                                            <div className="d-flex align-items-center action">
                                                                <Link
                                                                    className="btn-icon delete-icon confirm-text"
                                                                    to="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleVoidTabLine(line.TabLineID);
                                                                    }}
                                                                >
                                                                    <Trash2 className="feather-14" />
                                                                </Link>
                                                            </div>
                                                        </div>

                                                        {/* COLLAPSIBLE NOTES */}
                                                        {line._expanded && (
                                                            <div className="p-2 ps-4 text-muted small bg-light rounded">
                                                                {/* Extra Notes */}
                                                                {line.ExtraNotes && <div>Extra: {line.ExtraNotes}</div>}

                                                                {/* Auto Notes */}
                                                                {Array.isArray(line.AutoNotes) &&
                                                                    line.AutoNotes.map((n, i) => (
                                                                        <div key={i}>• {n}</div>
                                                                    ))}

                                                                {/* Ingredient Notes */}
                                                                {line.IngredientNotes &&
                                                                    Object.entries(line.IngredientNotes).map(([k, v]) =>
                                                                        v ? (
                                                                            <div key={k}>
                                                                                {k}: {v}
                                                                            </div>
                                                                        ) : null
                                                                    )}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}

                                        </div>

                                    </div>
                                    <div className="block-section">
                                        <table
                                            style={{
                                                width: "100%",
                                                marginTop: "8px",
                                                marginBottom: "8px",
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <tbody>
                                                <tr>
                                                    {/* ---------------- DISCOUNT ---------------- */}
                                                    <td style={{ paddingRight: "20px", textAlign: "center", color: "red" }}>
                                                        Discount
                                                        <table className="shadow-sm"
                                                            style={{
                                                                borderRadius: "10px",
                                                                height: "45px",
                                                                padding: "2px 6px",
                                                            }}
                                                        >
                                                            <tbody>
                                                                <tr>

                                                                    {/* LEFT SYMBOL ($) */}
                                                                    <td style={{ padding: "0px 1px 0px 6px", width: "10px" }}>
                                                                        {discountType === "$" && (
                                                                            <span style={{ fontSize: "15px" }}>$</span>
                                                                        )}
                                                                    </td>

                                                                    {/* INPUT */}
                                                                    <td style={{ padding: 0 }}>
                                                                        <input
                                                                            type="text"
                                                                            value={discountNumber}
                                                                            onFocus={(e) => e.target.select()}   // 🔥 Auto-select all
                                                                            onChange={(e) =>
                                                                                setDiscountNumber(e.target.value.replace(/[^0-9]/g, ""))
                                                                            }
                                                                            style={{
                                                                                border: "none",
                                                                                outline: "none",
                                                                                background: "transparent",
                                                                                width: `${Math.max(1, discountNumber.length)}ch`,
                                                                                minWidth: "80px",
                                                                                fontSize: "15px",
                                                                                textAlign: "left",
                                                                                padding: 0,
                                                                                color: "red"
                                                                            }}
                                                                        />

                                                                    </td>

                                                                    {/* RIGHT SYMBOL (%) */}
                                                                    <td style={{ padding: 0, width: "10px" }}>
                                                                        {discountType === "%" && (
                                                                            <span style={{ fontSize: "15px" }}>%</span>
                                                                        )}
                                                                    </td>
                                                                    {/* BUTTONS – ZERO GAP */}
                                                                    <td style={{ paddingLeft: "5px", paddingTop: "10px", paddingBottom: "10px" }}>
                                                                        <div style={{ display: "flex" }}>
                                                                            <Link to="#" className="pos-action-btn btn-primary" onClick={() => setDiscountType("$")}>
                                                                                <DollarSign className="feather-16" />
                                                                            </Link>
                                                                            <Link to="#" className="pos-action-btn btn-info" onClick={() => setDiscountType("%")}>
                                                                                <svg
                                                                                    className="feather-16"
                                                                                    width="16"
                                                                                    height="16"
                                                                                    viewBox="0 0 24 24"
                                                                                    fill="none"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth="2"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                >
                                                                                    <line x1="19" y1="5" x2="5" y2="19"></line>

                                                                                    <circle cx="7" cy="7" r="3.2"></circle>

                                                                                    <circle cx="17" cy="17" r="3.2"></circle>
                                                                                </svg>

                                                                            </Link>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>

                                                    {/* ---------------- GRATUITY ---------------- */}
                                                    <td className="success" style={{ textAlign: "center", color: "green" }}>
                                                        Gratuity
                                                        <table className="shadow-sm"
                                                            style={{
                                                                padding: "10px 14px",
                                                                borderRadius: "10px",
                                                                height: "45px",
                                                            }}
                                                        >
                                                            <tbody
                                                                style={{
                                                                    padding: "10px 14px",
                                                                    borderRadius: "10px",
                                                                    height: "45px",
                                                                }}>
                                                                <tr>

                                                                    {/* LEFT SYMBOL ($) */}
                                                                    <td style={{ padding: "0px 1px 0px 6px", width: "10px" }}>
                                                                        {gratuityType === "$" && (
                                                                            <span style={{ fontSize: "15px" }}>$</span>
                                                                        )}
                                                                    </td>

                                                                    {/* INPUT */}
                                                                    <td style={{ padding: "10px, 14px" }}>
                                                                        <input
                                                                            type="text"
                                                                            value={gratuityNumber}
                                                                            onFocus={(e) => e.target.select()}   // 🔥 Auto-select all
                                                                            onChange={(e) =>
                                                                                setGratuityNumber(
                                                                                    e.target.value.replace(/[^0-9]/g, "")
                                                                                )
                                                                            }
                                                                            style={{
                                                                                border: "none",
                                                                                outline: "none",
                                                                                background: "transparent",
                                                                                width: `${Math.max(1, gratuityNumber.length)}ch`,
                                                                                minWidth: "80px",
                                                                                fontSize: "15px",
                                                                                textAlign: "left",
                                                                                padding: 0,
                                                                                color: "green"
                                                                            }}
                                                                        />
                                                                    </td>

                                                                    {/* RIGHT SYMBOL (%) */}
                                                                    <td style={{ padding: 0, width: "10px" }}>
                                                                        {gratuityType === "%" && (
                                                                            <span style={{ fontSize: "15px" }}>%</span>
                                                                        )}
                                                                    </td>

                                                                    {/* BUTTONS */}
                                                                    <td style={{ paddingLeft: "5px", paddingTop: "10px", paddingBottom: "10px" }}>
                                                                        <div style={{ display: "flex" }}>
                                                                            <Link to="#" className="pos-action-btn btn-primary" onClick={() => setGratuityType("$")}>
                                                                                <DollarSign className="feather-16" />
                                                                            </Link>
                                                                            <Link to="#" className="pos-action-btn btn-info" onClick={() => setGratuityType("%")}>
                                                                                <svg
                                                                                    className="feather-16"
                                                                                    width="16"
                                                                                    height="16"
                                                                                    viewBox="0 0 24 24"
                                                                                    fill="none"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth="2"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                >
                                                                                    <line x1="19" y1="5" x2="5" y2="19"></line>

                                                                                    <circle cx="7" cy="7" r="3.2"></circle>

                                                                                    <circle cx="17" cy="17" r="3.2"></circle>
                                                                                </svg>

                                                                            </Link>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>

                                        <div className="order-total">
                                            <table className="table table-responsive table-borderless">
                                                <tbody>
                                                    <tr>
                                                        <td>Sub Total</td>
                                                        <td className="text-end">{currencySymbol}{subTotal.toFixed(2)}</td>
                                                    </tr>

                                                    <tr>
                                                        <td>Tax </td>
                                                        <td className="text-end">{currencySymbol}{taxValue.toFixed(2)}</td>
                                                    </tr>

                                                    <tr>
                                                        <td style={{ color: "red" }}>Discount (
                                                            {discountType === "%"
                                                                ? `${discountNumber}%`
                                                                : `${(((Number(discountNumber) + (Number(taxValue))) / subTotal) * 100 || 0).toFixed(0)}%`
                                                            }
                                                            )
                                                        </td>
                                                        <td style={{ color: "red" }} className="text-end">-{currencySymbol}{discountValue.toFixed(2)}</td>
                                                    </tr>

                                                    <tr>
                                                        <td style={{ color: "green" }}>Gratuity (
                                                            {gratuityType === "%"
                                                                ? `${gratuityNumber}%`
                                                                : `${(((Number(gratuityNumber) + (Number(taxValue))) / subTotal) * 100 || 0).toFixed(0)}%`
                                                            }
                                                            )
                                                        </td>
                                                        <td style={{ color: "green" }} className="text-end">{currencySymbol}{gratuityValue.toFixed(2)}</td>
                                                    </tr>


                                                </tbody>
                                            </table>
                                        </div>

                                    </div>

                                    {/* 🔽 MAIN PAYMENT METHOD ROW (your original boxes kept exactly the same) */}
                                    <div className="row g-3">

                                        {/* PRIMARY */}
                                        {primaryType && (
                                            <div className="col-md-4">
                                                <div
                                                    className={`p-3 rounded-3 shadow-sm text-center payment-box pos-hover ${selectedPaymentType?.PaymentTypeID === primaryType?.PaymentTypeID
                                                        ? "pos-selected"
                                                        : ""
                                                        }`}
                                                    onClick={() => handlePaymentTypeSelect(primaryType)}
                                                >

                                                    <i className="bi bi-credit-card fs-2"></i>
                                                    <p className="mb-0 mt-2">{primaryType.Name}</p>
                                                </div>
                                            </div>
                                        )}

                                        {/* SECONDARY */}
                                        {secondaryType && (
                                            <div className="col-md-4">
                                                <div
                                                    className={`p-3 rounded-3 shadow-sm text-center payment-box pos-hover ${selectedPaymentType?.PaymentTypeID === secondaryType?.PaymentTypeID
                                                        ? "pos-selected"
                                                        : ""
                                                        }`}
                                                    onClick={() => handlePaymentTypeSelect(secondaryType)}
                                                >

                                                    <i className="bi bi-wallet2 fs-2"></i>
                                                    <p className="mb-0 mt-2">{secondaryType.Name}</p>
                                                </div>
                                            </div>
                                        )}

                                        {/* OTHER (POP-OVER STYLE) */}
                                        <div className="col-md-4 position-relative">
                                            <div
                                                className={`p-3 rounded-3 shadow-sm text-center payment-box pos-hover ${selectedPaymentType &&
                                                    !selectedPaymentType.IsPrimary &&
                                                    !selectedPaymentType.IsSecondary
                                                    ? "pos-selected"
                                                    : ""
                                                    }`}
                                                onClick={() => setShowOtherExpanded(!showOtherExpanded)}
                                            >

                                                <i className="bi bi-grid fs-2"></i>
                                                <p className="mb-0 mt-2">
                                                    {selectedPaymentType &&
                                                        !selectedPaymentType.IsPrimary &&
                                                        !selectedPaymentType.IsSecondary
                                                        ? selectedPaymentType.Name
                                                        : "Other"}
                                                </p>
                                            </div>

                                            {/* POP-OVER ABOVE BUTTON */}
                                            {showOtherExpanded && (
                                                <div className="pos-other-popover">
                                                    <div className="pos-other-inner">

                                                        <div className="row g-3">
                                                            {otherTypes.map(pt => (
                                                                <div className="col-4" key={pt.PaymentTypeID}>
                                                                    <div
                                                                        className={`p-3 rounded-3 shadow-sm text-center payment-box pos-hover ${selectedPaymentType?.PaymentTypeID === pt.PaymentTypeID
                                                                            ? "pos-selected"
                                                                            : ""
                                                                            }`}
                                                                        onClick={() => {
                                                                            handlePaymentTypeSelect(pt);
                                                                            setShowOtherExpanded(false);
                                                                        }}
                                                                    >

                                                                        <i className="bi bi-grid fs-2"></i>
                                                                        <p className="mb-0 mt-2">{pt.Name}</p>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>

                                                    </div>
                                                </div>
                                            )}
                                        </div>


                                    </div>

                                    <hr />

                                    <div className="d-grid btn-block">
                                        <Link className="btn btn-secondary" to="#">
                                            Grand Total : ${grandTotal.toFixed(2)}
                                        </Link>
                                    </div>
                                    <div className="btn-row d-sm-flex align-items-center justify-content-between">

                                        <Link
                                            to="#"
                                            className="btn btn-danger btn-icon flex-fill"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleVoidTab();
                                            }}
                                        >

                                            <span className="me-1 d-flex align-items-center">
                                                <i data-feather="trash-2" className="feather-16" />
                                            </span>
                                            Void
                                        </Link>
                                        <Link
                                            to="#"
                                            className="btn btn-success btn-icon flex-fill"
                                            data-bs-toggle="modal"
                                            data-bs-target="#payment-completed"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handlePaySale();
                                            }}
                                        >
                                            <span className="me-1 d-flex align-items-center">
                                                <i data-feather="credit-card" className="feather-16" />
                                            </span>
                                            Payment
                                        </Link>
                                    </div>
                                </aside>
                            </div>
                        )}
                        {currentTab === "history" && (
                            <div className="col-md-12 col-lg-12 ps-0">

                                {/* GUEST CATEGORIES */}
                                <div className="category-block p-3">
                                    <h5 className="mb-3">Guests</h5>

                                    <div
                                        className="d-flex flex-wrap gap-3"
                                        style={{ rowGap: "20px", columnGap: "20px" }}
                                    >
                                        {historyGuests
                                            .sort((a, b) => {
                                                if (a.GuestName === "Unassigned") return -1;
                                                if (b.GuestName === "Unassigned") return 1;
                                                return 0;
                                            })
                                            .map((guest, index) => (

                                                <div
                                                    key={index}
                                                    className="category-card shadow-sm p-3 text-center"
                                                    style={{
                                                        background:
                                                            selectedHistoryGuest?.GuestName === guest.GuestName
                                                                ? "#eef6ff"
                                                                : "white",
                                                        border:
                                                            selectedHistoryGuest?.GuestName === guest.GuestName
                                                                ? "2px solid #0d6efd"
                                                                : "1px solid #ddd",
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() => setSelectedHistoryGuest(guest)}
                                                >
                                                    <img
                                                        src="assets/img/users/user-01.jpg"
                                                        className="img-fluid mb-2"
                                                        alt="guest"
                                                        style={{ borderRadius: "50%", width: 60, height: 60 }}
                                                    />

                                                    <h6 className="mb-1">
                                                        {guest.GuestName === "Unassigned" ? "Other" : guest.GuestName}
                                                    </h6>


                                                    <span className="badge bg-primary">
                                                        {guest.Products?.length || 0} Products
                                                    </span>
                                                </div>
                                            ))}
                                    </div>
                                </div>

                                {/* PRODUCT BLOCKS */}
                                <div className="products-area mt-4 p-3">
                                    {/* If a guest is selected → show only their products */}
                                    {selectedHistoryGuest ? (
                                        <div className="mb-5">
                                            <h5 className="mb-3">
                                                {selectedHistoryGuest.GuestName === "Unassigned" ? "Other" : selectedHistoryGuest.GuestName}
                                            </h5>
                                            <div
                                                className="d-flex flex-wrap"
                                                style={{
                                                    gap: "15px",
                                                    rowGap: "25px"
                                                }}
                                            >
                                                {selectedHistoryGuest.Products.map((prod, pIndex) => (
                                                    <div
                                                        key={pIndex}
                                                        className="pos-product-card-wide card"
                                                        onClick={() => handleReorderProduct(prod)}
                                                        style={{
                                                            cursor: "pointer",
                                                            width: "140px",
                                                            height: "140px",
                                                            borderRadius: "6px"
                                                        }}
                                                    >
                                                        <div
                                                            className="pos-product-image-wide"
                                                            style={{
                                                                background: "#f5f7fb",
                                                                borderRadius: "6px",
                                                                height: "95px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}
                                                        >
                                                            <img
                                                                src={prod.ImageUrl || "assets/img/products/noProduct.jpg"}
                                                                alt={prod.Product}
                                                                style={{ maxHeight: "80%", maxWidth: "80%" }}
                                                            />
                                                        </div>

                                                        <div style={{ padding: "8px 10px" }}>
                                                            <h6 className="mb-0" style={{ fontSize: "14px", fontWeight: "600" }}>
                                                                {prod.Product}
                                                            </h6>
                                                            <p className="mt-1" style={{ fontSize: 12, opacity: 0.7 }}>
                                                                {prod.UnitCostIncl}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        /* Otherwise show ALL guests & their product groups */
                                        <>
                                            {historyGuests
                                                .filter(g => g.GuestName === "Unassigned")
                                                .map((guest, gIndex) => (

                                                    <div key={gIndex} className="mb-5">
                                                        <h5 className="mb-3">
                                                            {guest.GuestName === "Unassigned" ? "Other" : guest.GuestName}
                                                        </h5>
                                                        <div
                                                            className="d-flex flex-wrap"
                                                            style={{
                                                                gap: "15px",
                                                                rowGap: "25px"
                                                            }}
                                                        >
                                                            {guest.Products.map((prod, pIndex) => (
                                                                <div
                                                                    key={pIndex}
                                                                    className="pos-product-card-wide card"
                                                                    onClick={() => handleReorderProduct(prod)}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        width: "140px",
                                                                        height: "140px",
                                                                        borderRadius: "6px"
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="pos-product-image-wide"
                                                                        style={{
                                                                            background: "#f5f7fb",
                                                                            borderRadius: "6px",
                                                                            height: "95px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center"
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={prod.ImageUrl || "assets/img/products/noProduct.jpg"}
                                                                            alt={prod.Product}
                                                                            style={{ maxHeight: "80%", maxWidth: "80%" }}
                                                                        />
                                                                    </div>

                                                                    <div style={{ padding: "8px 10px" }}>
                                                                        <h6
                                                                            className="mb-0"
                                                                            style={{ fontSize: "14px", fontWeight: "600" }}
                                                                        >
                                                                            {prod.Product}
                                                                        </h6>
                                                                        <p className="mt-1" style={{ fontSize: 12, opacity: 0.7 }}>
                                                                            {prod.UnitCostIncl}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                        </>
                                    )}

                                </div>

                            </div>
                        )}


                    </div>

                </div>
            </div>

            {/* Payment Completed */}
            <div
                className="modal fade modal-default"
                id="payment-completed"
                aria-labelledby="payment-completed"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <form>
                                <div className="icon-head">
                                    <Link to="#">
                                        <CheckCircle className="feather-40" />
                                    </Link>
                                </div>
                                <h4>Payment Completed</h4>
                                <p className="mb-0">
                                    Do you want to Print Receipt for the Completed Order
                                </p>
                                <div className="modal-footer d-sm-flex justify-content-between">
                                    <button
                                        type="button"
                                        className="btn btn-primary flex-fill me-1"
                                        data-bs-toggle="modal"
                                        data-bs-target="#print-receipt"
                                    >
                                        Print Receipt
                                    </button>
                                    <Link to="#" className="btn btn-secondary flex-fill">
                                        Next Order
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Payment Completed */}
            {/* Print Receipt */}
            <div
                className="modal fade modal-default"
                id="print-receipt"
                aria-labelledby="print-receipt"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="close p-0"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="icon-head text-center">
                                <Link to="#">
                                    <ImageWithBasePath
                                        src="assets/img/logo.png"
                                        width={100}
                                        height={30}
                                        alt="Receipt Logo"
                                    />
                                </Link>
                            </div>
                            <div className="text-center info text-center">
                                <h6>Dreamguys Technologies Pvt Ltd.,</h6>
                                <p className="mb-0">Phone Number: +1 5656665656</p>
                                <p className="mb-0">
                                    Email: <Link to="mailto:example@gmail.com">example@gmail.com</Link>
                                </p>
                            </div>
                            <div className="tax-invoice">
                                <h6 className="text-center">Tax Invoice</h6>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                        <div className="invoice-user-name">
                                            <span>Name: </span>
                                            <span>John Doe</span>
                                        </div>
                                        <div className="invoice-user-name">
                                            <span>Invoice No: </span>
                                            <span>CS132453</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <div className="invoice-user-name">
                                            <span>Customer Id: </span>
                                            <span>#LL93784</span>
                                        </div>
                                        <div className="invoice-user-name">
                                            <span>Date: </span>
                                            <span>01.07.2022</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table className="table-borderless w-100 table-fit">
                                <thead>
                                    <tr>
                                        <th># Item</th>
                                        <th>Price</th>
                                        <th>Qty</th>
                                        <th className="text-end">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1. Cheese Burger</td>
                                        <td>$50</td>
                                        <td>3</td>
                                        <td className="text-end">$150</td>
                                    </tr>
                                    <tr>
                                        <td>2. Steak Burger</td>
                                        <td>$50</td>
                                        <td>2</td>
                                        <td className="text-end">$100</td>
                                    </tr>
                                    <tr>
                                        <td>3. Apple Series 8</td>
                                        <td>$50</td>
                                        <td>3</td>
                                        <td className="text-end">$150</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>
                                            <table className="table-borderless w-100 table-fit">
                                                <tbody>
                                                    <tr>
                                                        <td>Sub Total :</td>
                                                        <td className="text-end">$700.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Discount :</td>
                                                        <td className="text-end">-$50.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Shipping :</td>
                                                        <td className="text-end">0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Tax (5%) :</td>
                                                        <td className="text-end">$5.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Bill :</td>
                                                        <td className="text-end">$655.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Due :</td>
                                                        <td className="text-end">$0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Payable :</td>
                                                        <td className="text-end">$655.00</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="text-center invoice-bar">
                                <p>
                                    **VAT against this challan is payable through central
                                    registration. Thank you for your business!
                                </p>
                                <Link to="#">
                                    <ImageWithBasePath src="assets/img/barcode/barcode-03.jpg" alt="Barcode" />
                                </Link>
                                <p>Sale 31</p>
                                <p>Thank You For Shopping With Us. Please Come Again</p>
                                <Link to="#" className="btn btn-primary">
                                    Print Receipt
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Print Receipt */}
            {/* Products */}
            <div
                className="modal fade modal-default pos-modal"
                id="products"
                aria-labelledby="products"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header p-4 d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <h5 className="me-4">Products</h5>
                                <span className="badge bg-info d-inline-block mb-0">
                                    Order ID : #666614
                                </span>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body p-4">
                            <form>
                                <div className="product-wrap">
                                    <div className="product-list d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center flex-fill">
                                            <Link to="#" className="img-bg me-2">
                                                <ImageWithBasePath
                                                    src="assets/img/products/tempburger.jpg"
                                                    alt="Products"
                                                />
                                            </Link>
                                            <div className="info d-flex align-items-center justify-content-between flex-fill">
                                                <div>
                                                    <span>PT0005</span>
                                                    <h6>
                                                        <Link to="#">Cheese Burger</Link>
                                                    </h6>
                                                </div>
                                                <p>$10</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="product-list d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center flex-fill">
                                            <Link to="#" className="img-bg me-2">
                                                <ImageWithBasePath
                                                    src="assets/img/products/tempburger.jpg"
                                                    alt="Products"
                                                />
                                            </Link>
                                            <div className="info d-flex align-items-center justify-content-between flex-fill">
                                                <div>
                                                    <span>PT0235</span>
                                                    <h6>
                                                        <Link to="#">Steak Burger</Link>
                                                    </h6>
                                                </div>
                                                <p>$15</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="product-list d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center flex-fill">
                                            <Link to="#" className="img-bg me-2">
                                                <ImageWithBasePath
                                                    src="assets/img/products/tempburger.jpg"
                                                    alt="Products"
                                                />
                                            </Link>
                                            <div className="info d-flex align-items-center justify-content-between flex-fill">
                                                <div>
                                                    <span>PT0005</span>
                                                    <h6>
                                                        <Link to="#">Cheese Burger</Link>
                                                    </h6>
                                                </div>
                                                <p>$10</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="product-list d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center flex-fill">
                                            <Link to="#" className="img-bg me-2">
                                                <ImageWithBasePath
                                                    src="assets/img/products/tempburger.jpg"
                                                    alt="Products"
                                                />
                                            </Link>
                                            <div className="info d-flex align-items-center justify-content-between flex-fill">
                                                <div>
                                                    <span>PT0005</span>
                                                    <h6>
                                                        <Link to="#">Cheese Burger</Link>
                                                    </h6>
                                                </div>
                                                <p>$10</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer d-sm-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                    >
                                        Cancel
                                    </button>
                                    <Link to="#" className="btn btn-primary">
                                        Submit
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Products */}
            <div
                className="modal fade"
                id="create"
                tabIndex={-1}
                aria-labelledby="create"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-lg modal-dialog-centered"
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Create</h5>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks">
                                            <label>Customer Name</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks">
                                            <label>Email</label>
                                            <input type="email" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks">
                                            <label>Phone</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks">
                                            <label>Country</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks">
                                            <label>City</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks">
                                            <label>Address</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer d-sm-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-cancel"
                                        data-bs-dismiss="modal"
                                    >
                                        Cancel
                                    </button>
                                    <Link to="#" className="btn btn-submit me-2">
                                        Submit
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* Hold */}
            <div
                className="modal fade modal-default pos-modal"
                id="hold-order"
                aria-labelledby="hold-order"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header p-4">
                            <h5>Hold order</h5>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body p-4">
                            <form>
                                <h2 className="text-center p-4">4500.00</h2>
                                <div className="input-block">
                                    <label>Order Reference</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        defaultValue=""
                                        placeholder=""
                                    />
                                </div>
                                <p>
                                    The current order will be set on hold. You can retreive this order
                                    from the pending order button. Providing a reference to it might
                                    help you to identify the order more quickly.
                                </p>
                                <div className="modal-footer d-sm-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                    >
                                        Cancel
                                    </button>
                                    <Link to="#" className="btn btn-primary">
                                        Confirm
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Hold */}
            {/* Edit Product */}
            <div
                className="modal fade modal-default pos-modal"
                id="edit-product"
                aria-labelledby="edit-product"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header p-4">
                            <h5>Cheese Burger</h5>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body p-4">
                            <form>
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks add-product">
                                            <label>
                                                Product Name <span>*</span>
                                            </label>
                                            <input type="text" placeholder={45} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks add-product">
                                            <label>
                                                Tax Type <span>*</span>
                                            </label>
                                            <Select
                                                classNamePrefix="react-select"
                                                options={tax}
                                                placeholder="Select Option"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks add-product">
                                            <label>
                                                Tax <span>*</span>
                                            </label>
                                            <input type="text" placeholder="% 15" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks add-product">
                                            <label>
                                                Discount Type <span>*</span>
                                            </label>
                                            <Select
                                                classNamePrefix="react-select"
                                                options={discounttype}
                                                placeholder="Select Option"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks add-product">
                                            <label>
                                                Discount <span>*</span>
                                            </label>
                                            <input type="text" placeholder={15} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-12">
                                        <div className="input-blocks add-product">
                                            <label>
                                                Sale Unit <span>*</span>
                                            </label>
                                            <Select
                                                classNamePrefix="react-select"
                                                options={units}
                                                placeholder="Select Option"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer d-sm-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                    >
                                        Cancel
                                    </button>
                                    <Link to="#" className="btn btn-primary">
                                        Submit
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Edit Product */}
            {/* Recent Transactions */}
            <div
                className="modal fade pos-modal"
                id="recents"
                tabIndex={-1}
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-lg modal-dialog-centered"
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-header p-4">
                            <h5 className="modal-title">Recent Transactions</h5>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body p-4">
                            <div className="tabs-sets">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="purchase-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#purchase"
                                            type="button"
                                            aria-controls="purchase"
                                            aria-selected="true"
                                            role="tab"
                                        >
                                            Purchase
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="payment-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#payment"
                                            type="button"
                                            aria-controls="payment"
                                            aria-selected="false"
                                            role="tab"
                                        >
                                            Payment
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="return-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#return"
                                            type="button"
                                            aria-controls="return"
                                            aria-selected="false"
                                            role="tab"
                                        >
                                            Return
                                        </button>
                                    </li>
                                </ul>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="purchase"
                                        role="tabpanel"
                                        aria-labelledby="purchase-tab"
                                    >
                                        <div className="table-top">
                                            <div className="search-set">
                                                <div className="search-input">
                                                    <input
                                                        type="text"
                                                        placeholder="Search"
                                                        className="form-control form-control-sm formsearch"
                                                    />
                                                    <Link to className="btn btn-searchset">
                                                        <i data-feather="search" className="feather-search" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="wordset">
                                                <ul>
                                                    <li>
                                                        <OverlayTrigger placement="top" overlay={renderTooltip}>
                                                            <Link>
                                                                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                    </li>
                                                    <li>
                                                        <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                                            <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                                                <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                    </li>
                                                    <li>
                                                        <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                                            <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                                                <i data-feather="printer" className="feather-printer" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table datanew">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Reference</th>
                                                        <th>Customer</th>
                                                        <th>Amount </th>
                                                        <th className="no-sort">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0101</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0102</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0103</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0104</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0105</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0106</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0107</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="payment" role="tabpanel">
                                        <div className="table-top">
                                            <div className="search-set">
                                                <div className="search-input">
                                                    <input
                                                        type="text"
                                                        placeholder="Search"
                                                        className="form-control form-control-sm formsearch"
                                                    />
                                                    <Link to className="btn btn-searchset">
                                                        <i data-feather="search" className="feather-search" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="wordset">
                                                <ul>
                                                    <li>
                                                        <OverlayTrigger placement="top" overlay={renderTooltip}>
                                                            <Link>
                                                                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                    </li>
                                                    <li>
                                                        <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                                            <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                                                <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                    </li>
                                                    <li>
                                                        <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                                            <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                                                <i data-feather="printer" className="feather-printer" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table datanew">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Reference</th>
                                                        <th>Customer</th>
                                                        <th>Amount </th>
                                                        <th className="no-sort">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0101</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0102</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0103</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0104</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0105</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0106</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0107</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="return" role="tabpanel">
                                        <div className="table-top">
                                            <div className="search-set">
                                                <div className="search-input">
                                                    <input
                                                        type="text"
                                                        placeholder="Search"
                                                        className="form-control form-control-sm formsearch"
                                                    />
                                                    <Link to className="btn btn-searchset">
                                                        <i data-feather="search" className="feather-search" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="wordset">
                                                <ul>
                                                    <li>
                                                        <OverlayTrigger placement="top" overlay={renderTooltip}>
                                                            <Link>
                                                                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                    </li>
                                                    <li>
                                                        <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                                            <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                                                <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                    </li>
                                                    <li>
                                                        <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                                            <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                                                <i data-feather="printer" className="feather-printer" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table datanew">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Reference</th>
                                                        <th>Customer</th>
                                                        <th>Amount </th>
                                                        <th className="no-sort">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0101</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0102</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0103</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0104</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0105</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0106</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19 Jan 2023</td>
                                                        <td>INV/SL0107</td>
                                                        <td>Walk-in Customer</td>
                                                        <td>$1500.00</td>
                                                        <td className="action-table-data">
                                                            <div className="edit-delete-action">
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="eye" className="feather-eye" />
                                                                </Link>
                                                                <Link className="me-2 p-2" to="#">
                                                                    <i data-feather="edit" className="feather-edit" />
                                                                </Link>
                                                                <Link onClick={showConfirmationAlert}
                                                                    className="p-2 confirm-text"
                                                                    to="#"
                                                                >
                                                                    <i
                                                                        data-feather="trash-2"
                                                                        className="feather-trash-2"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Recent Transactions */}


            {
                <ManagerApprovalModal
                    isOpen={showManagerModal}
                    onClose={() => {
                        setShowManagerModal(false);
                        setManagerAction(null);
                    }}
                    onApproved={() => {
                        if (managerAction) {
                            managerAction();
                            setManagerAction(null);
                        }
                        setShowManagerModal(false);
                    }}
                />
            }
            {
                <PosLocationModal
                    isOpen={showLocationModal}
                    onClose={() => setShowLocationModal(false)}
                    onSelect={handleLocationSelect}
                />
            }
            {
                <PriceCodeModal
                    isOpen={showPriceModal}
                    onClose={() => setShowPriceModal(false)}
                    productId={selectedProductId}
                    productName={currentProductName}
                    onAdd={(selected) => {
                        // 🔥 NEW: ensure this path is always treated as "add", not "edit"
                        setEditingIndex(null);

                        setSelectedPriceItems(selected);                  // store selected price rows
                        setShowPriceModal(false);                        // close PriceCodeModal
                        setTimeout(() => setShowAddProductOptionsModal(true), 50); // open modal #2
                    }}

                />
            }
            {
                <PosMenuModal
                    isOpen={showMenuModal}
                    onClose={() => setShowMenuModal(false)}
                    costCenter={selectedCostCenter}   // ✅ THE FIX
                    onSelect={(label, menuId) => {
                        localStorage.setItem("selectedMenuId", menuId);
                        setShowMenuModal(false);
                        setSelectedMenuId(menuId);
                    }}
                />

            }
            {
                <PosViewTabModal
                    isOpen={showViewTabModal}
                    onClose={() => setShowViewTabModal(false)}
                />
            }
            {
                <AddProductOptionsModal
                    isOpen={showAddProductOptionsModal}
                    onClose={() => {
                        setShowAddProductOptionsModal(false);
                        setEditingIndex(null);     // ✅ Fix overwrite issue
                    }}
                    selectedItems={selectedPriceItems}
                    productId={selectedProductId}
                    productName={currentProductName}
                    editIndex={editingIndex}   // 🔥 NEW
                    tabId={selectedTab?.TabID ?? null}   // ✅ pass active POS tab id
                    accountId={selectedTab?.FK_AccountID ?? null} // <-- ADD THIS
                />

            }

            {
                editingRow && (
                    <AddProductEditModal
                        isOpen={true}
                        rowData={editingRow.row}
                        onClose={() => setEditingRow(null)}
                        onSave={(notes) => {
                            const updated = [...selectedPriceItems];
                            updated[editingRow.index].notes = notes;
                            setSelectedPriceItems(updated);
                            setEditingRow(null);
                        }}
                    />
                )
            }
            {
                <StaffPinModal
                    isOpen={showStaffPinModal}
                    onClose={() => setShowStaffPinModal(false)}
                    onApproved={(staff) => {
                        setTabStaffSession(staff);      // save StaffID for the new tab
                        setShowStaffPinModal(false);    // close PIN modal
                        setShowAddTabModal(true);       // open AddTabModal
                    }}
                />
            }
            {
                <AddTabModal
                    isOpen={showAddTabModal}
                    onClose={() => setShowAddTabModal(false)}
                    costCenter={selectedCostCenter}
                    staff={tabStaffSession}   // 🔥 gives FK_StaffID to modal
                    onSave={async (rec) => {

                        // Ensure staff and cost center included
                        rec.FK_StaffID = tabStaffSession?.StaffID;
                        rec.FK_CostCenterID = selectedCostCenter?.CostCenterID;

                        const result = await TabService.addTab(rec);

                        if (result) {
                            Swal.fire("Success", "Tab created!", "success");

                            // 🔥 Save newly created tab so the UI can show its name
                            setSelectedTab({
                                TabID: result.TabID ?? result.TabId,
                                TabName: rec.TabName,
                                TableNumber: rec.TableNumber && Number(rec.TableNumber) > 0
                                    ? Number(rec.TableNumber)
                                    : null,
                                FK_AccountID: rec.FK_AccountID,   // 🔥 REQUIRED
                            });

                            setShowAddTabModal(false);
                        }
                    }}
                />

            }
            {
                <TabSelectModal
                    isOpen={showTabSelectModal}
                    onClose={() => setShowTabSelectModal(false)}
                    onSelect={async (tab) => {
                        setSelectedTab({
                            TabID: tab.TabID ?? tab.TabId,
                            TabName: tab.TabName ?? tab.AccountName,
                            TableNumber: tab.TableNumber && Number(tab.TableNumber) > 0
                                ? Number(tab.TableNumber)
                                : null,
                            FK_AccountID: tab.FK_AccountID,    // 🔥 REQUIRED
                        });
                        setShowTabSelectModal(false);

                        const rawLines = await TabService.getTabLinesById(tab.TabID);

                        const cleaned = (rawLines ?? []).map((p) => ({
                            TabLineID: p.TabLineID,
                            FK_ProductID: p.FK_ProductID,
                            Product: p.Product,
                            PriceCode: p.PriceCode,
                            Quantity: Number(
                                p.Quantity?.parsedValue ??
                                p.Quantity ??
                                1
                            ),
                            UnitCostIncl: Number(
                                p.UnitCostIncl?.parsedValue ??
                                p.UnitCostIncl ??
                                0
                            ),
                            Notes: p.Notes ?? "",
                            Options: p.Options ?? [],
                            IsTemp: false,
                        }));

                        // 💥 NOTE: We NO LONGER MERGE THIS WITH TEMP PRODUCTS
                        setTabProducts(cleaned);

                        // Reset temp list so only DB items appear under 'Product Added'
                        setTempProducts([]);

                        // UI resets
                        setSelectedMainCategoryId(null);
                        setSelectedMainCategoryName("");
                        setMenuProducts([]);
                        setMainCategories([]);

                        if (selectedMenuId) {
                            loadMainCategories(selectedMenuId);
                        }
                    }}

                />

            }
        </div>

    )
}

export default Pos